import { widgetMeta } from "./widgetMeta";
import { getWidgetRenderers } from "./widgetRenderers";

export default function GetWidgetData(
  widgetRefresh,
  setWidgetRefresh,
  sidebarOpen
) {
  // Compose metadata + renderers into the shape expected by the dashboard/admin screens.
  const renderers = getWidgetRenderers(
    widgetRefresh,
    setWidgetRefresh,
    sidebarOpen
  );

  return Object.fromEntries(
    Object.entries(widgetMeta).map(([id, meta]) => [
      id,
      {
        ...meta,
        component: renderers[id],
      },
    ])
  );
}
